import React from 'react'
import './index.css'

const PlainHeader = () => {
  return (
    <div className='mHead'>
      <a href='https://dadopa.cz/'><h2 className='mHead-h2'>Dadopa</h2></a>
    </div>
  )
}

export default PlainHeader



// WEBPACK FOOTER //
// ./src/components/AppHeader/PlainHeader.js